import React, { Component } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import category from '../../../../store/modules/category';

import * as func from "../../../../utils/functions";

import {MESSAGE, EDIT_MODE} from "../../../../wpconfig"

import * as FActions from "../../../../store/modules/footer";

import InputBox from '../../../etc/InputBox'
import Treebox from '../../../etc/TreeBox'

class Category extends Component {
  constructor(props) {
    super(props);

		this.state = {
			category: [],
			param: {
        "up_category_id": 0,
        "category_name": "",
        "category_desc": "",
        "slug": "",
        "category_count": "0",
        "category_type": this.props.type,
        "depth_level": 1,
        "disp_yn": "Y",
        "del_yn": "N",
        "is_edit" : EDIT_MODE.SHOW_EDIT,
			},
      field : 'category',
			category_id: [],
			isInit: false,
			action: 'category/' + this.props.type
		}

		func.getData(this.state.action, null).then((response) => {      
      this.setCategory(response.records) 
		});

		this.sortData = this.sortData.bind(this);
		this.onInsert = this.onInsert.bind(this);
		this.setCategory = this.setCategory.bind(this);
    this.showMessage = this.showMessage.bind(this);
	}

  sortData(data) {
    const t = {};
    t.category = [];
    t.isInit = true;

    this.setState({ category: data })
    this.forceUpdate();
  }

	onInsert() {    
    func.updateData(this.state.field+"/insert", this.state.param).then((response) => {
      if (response.code === 'ok') {
				let p = {
					"category_id" : response.category_id,
					"up_category_id": this.up_category_id.value === "" ? 0 : this.up_category_id.value,
					"category_name": this.category_name.value,
					"slug": this.slug.value,
					"depth_level": this.up_category_id.value === "" ? 1 : 2,
					"is_edit" : EDIT_MODE.SHOW,
				}
	      const cate = func.deepClone(this.state.category);
				cate.push(p)
        this.setCategory(cate)
        this.showMessage('추가 되었습니다.');
      } else {
        this.showMessage('저장 실패 : ' + response.message);
      }
    });
	}

  async setCategory(data) {
    await this.setState({ category: data }, () => { this.forceUpdate() })
  }

	change = (event) => {
		const record = this.state.param;
		record[event.target.name] = event.target.value;
    this.setState({ param : record })
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

  render() {
    return (
      <>
        <label htmlFor="journal_title"><strong>Add New {this.props.title}</strong></label>
        <div className="row mt-4">
          <div className="col-md-5">
            <div className="mt-2">
              <label htmlFor="input"><strong>이름</strong></label>
              <input
							 	type="text" 
								name="category_name" 
								className="form-control" 
								ref={(ref)=>this.category_name=ref}
                value={this.state.param.category_name}
							  // defaultValue={this.state.param.category_name || ""}
								onChange={this.change}
							  />
              <label className="form-label">이름은 사이트에 보이는 방법입니다.</label>
            </div>
            <div className="mt-2">
              <label htmlFor="input"><strong>슬러그</strong></label>
              <input
							 	type="text" 
								name="slug" 
								className="form-control" 
								ref={(ref)=>this.slug=ref}
                value={this.state.param.slug}
							  // defaultValue={this.state.param.slug || ""}
								onChange={this.change}
							  />
              <label className="form-label">'슬러그'는 이름의 URL 친화적인 버전입니다. 이는 보통 모두 소문자이고 문자, 숫자, 그리고 하이픈만 포함합니다.</label>
            </div>
            <div className="mt-2">
							<select className="form-control form-control-sm"
                      value={this.state.param.up_category_id}
							        // defaultValue={this.state.param.up_category_id || 0}
							        ref={(ref)=>this.up_category_id=ref}
							        name="up_category_id"
							        onChange={this.change}
							>
                <option value="" checked="checked">없음</option>
								{this.state.category.length > 0 && this.state.category.filter(f => f.up_category_id === 0).map((type, i) => {
									return (<option key={type.category_id} value={type.category_id}>{type.category_name}</option>)
								})}
							</select>
              <label className="form-label">부모 용어를 지정하여 계층을 만듭니다. 예를 들어 용어 재즈는 비빌과 빅 밴드의 부모입니다.</label>
            </div>
            <button type="button" className="btn btn-sm btn-primary" onClick={this.onInsert}>
              추가
            </button>
          </div>
          <div className="col-md-7">
            {
              this.state.category.length > 0 && (
                <Treebox 
                  category={this.state.category}
                  type={this.props.type}
                  action={this.state.action}
                  setCategory={this.setCategory}
                />
              )
            }
          </div>
        </div>
      </>
    )
  }
}

export default connect(
	(state) => ({
	}),
	(dispatch) => ({
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
) (Category)

